import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/contratos/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&classificacao=${filtro.classificacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedores() {
        return axiosJwt
            .get(`${api}/contratos/fornecedores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedoresContratos(codFornecedor) {
        return axiosJwt
            .get(`${api}/contratos/fornecedores/${codFornecedor}/contratos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/contratos/pagamentos/${pagamentoId}/comprometimentosdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarComprometimentos(pagamentoComprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${pagamentoComprometimentos.pagamentoId}/associarcomprometimentos`,
                pagamentoComprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarComprometimento(pagamentoComprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${pagamentoComprometimento.pagamentoId}/desassociarcomprometimento`,
                pagamentoComprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(pagamentoId) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/${pagamentoId}/anexos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamento(fornecedor) {
        return axiosJwt
            .post(`${api}/contratos/pagamentos`, fornecedor)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos(tipo) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/anexos/tipos/${tipo}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    validarInserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroDocumento', pagamentoAnexo.numeroDocumento)
        if (pagamentoAnexo.dataEmissao != null) {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos/validar`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroDocumento', pagamentoAnexo.numeroDocumento)
        if (pagamentoAnexo.dataEmissao != null) {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }
        if (pagamentoAnexo.justificativa != null) {
            formData.append(
                'justificativaAnexoDuplicado',
                pagamentoAnexo.justificativa
            )
        }

        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${pagamentoDto.pagamentoId}/analisar`,
                pagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/anexos/${pagamentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarPagamento(aprovaReprovaPagamentoDto) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/aprovar`,
                aprovaReprovaPagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/contratos/pagamentos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/contratos/pagamentos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/contratos/pagamentos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarAutorizcao(solicitacaoDto) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${solicitacaoDto.pagamentoId}/solicitarautorizacao`,
                solicitacaoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSolicitacoes(status) {
        let url = `${api}/contratos/pagamentos/solicitacoes?status=${status}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    processarSolicitacao(solicitacaoDto) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${solicitacaoDto.pagamentoId}/processarsolicitacao`,
                solicitacaoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(pagamentoId) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/${pagamentoId}/certidoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarObservacoes(pagamentoObservacoesDto) {
        return axiosJwt
            .post(
                `${api}/contratos/pagamentos/${pagamentoObservacoesDto.pagamentoId}/atualizarobservacoes`,
                pagamentoObservacoesDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirPrioritario(pagamentoId) {
        return axiosJwt
            .patch(`${api}/contratos/pagamentos/${pagamentoId}/prioritario`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirEspecial(pagamentoId) {
        return axiosJwt
            .patch(`${api}/contratos/pagamentos/${pagamentoId}/especial`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(pagamentoId) {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/${pagamentoId}/exportar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    retornarPagamento(pagamentoId) {
        return axiosJwt
            .patch(`${api}/contratos/pagamentos/${pagamentoId}/retornaruabs`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasReprovacao() {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/reprovarpagamentoopcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasAprovacaoJustificada() {
        return axiosJwt
            .get(`${api}/contratos/pagamentos/aprovacaojustificadaopcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
